import { useSelector } from 'react-redux';
import useFetchDataSources from './useFetchDataSources';
import { selectQuickFiltersDataSources } from '../../../../../ducks/quick-filters';
const useQuickFilterFetchDataSources = () => {
  const dataSourceKeys = useSelector(selectQuickFiltersDataSources);
  const fetchDataStatus = useFetchDataSources(dataSourceKeys);
  return fetchDataStatus;
};
export default useQuickFilterFetchDataSources;